import type { Theme } from "./type";

export const defaultTheme: Theme = {
  dark: false,

  colors: {
    primary: "#000000",
    secondary: "#F50E01",
    background: "#FFFFFF",

    surface: "#FFFFFF",
    "surface-bright": "#FFFFFF",
    "surface-light": "#EEEEEE",
    "surface-variant": "#424242",
    "on-surface-variant": "#EEEEEE",
    "primary-darken-1": "#1F5592",
    "secondary-darken-1": "#018786",
    error: "#B00020",
    info: "#2196F3",
    success: "#4CAF50",
    warning: "#FB8C00",
  },
};

export const ssn: Theme = {
  dark: false,

  colors: {
    primary: "#fff",
    secondary: "#54B6B2",
    background: "#000000",

    surface: "#212121",
    "surface-bright": "#ccbfd6",
    "surface-light": "#424242",
    "surface-variant": "#a3a3a3",
    "on-surface-variant": "#424242",
    "primary-darken-1": "#277CC1",
    "secondary-darken-1": "#48A9A6",
    error: "#CF6679",
    info: "#2196F3",
    success: "#4CAF50",
    warning: "#FB8C00",
  },
};

export const test: Theme = {
  dark: false,
  // @ts-ignore
  colors: {
    background: "#f74747",
  },
};

export const themes = {
  defaultTheme,
  ssn,
  test,
};
